import { Controller } from "@api/config";

import type { TGetNewsListRequest } from "./request.types";
import type { TGetNewsListResponse } from "./response.types";

class NewsController extends Controller {
	public constructor() {
		super({ requestUrl: "api/news/models" });
	}

	/**@GET NEWS LIST */
	public async getNewsListAsync({ modelNickName }: TGetNewsListRequest) {
		return this.get<TGetNewsListResponse[]>("hub", `?modelName=${modelNickName}`);
	}
}

export const newsAPI = new NewsController();
